
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"40","height":"40","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"id-62a","width":"181.2%","height":"181.2%","x":"-40.6%","y":"-28.1%","filterUnits":"objectBoundingBox"}},[_c('feMorphology',{attrs:{"in":"SourceAlpha","operator":"dilate","radius":"1","result":"shadowSpreadOuter1"}}),_c('feOffset',{attrs:{"dy":"2","in":"shadowSpreadOuter1","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter1","result":"shadowBlurOuter1","stdDeviation":"1.5"}}),_c('feComposite',{attrs:{"in":"shadowBlurOuter1","in2":"SourceAlpha","operator":"out","result":"shadowBlurOuter1"}}),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter1","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.117761145 0"}})]),_c('path',{attrs:{"id":"id-63b","d":"M20 12a1 1 0 011 1v6h6a1 1 0 010 2h-6v6a1 1 0 01-2 0v-6h-6a1 1 0 010-2h6v-6a1 1 0 011-1z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#FFF","fill-opacity":".3"}}),_c('use',{attrs:{"fill":"#000","filter":"url(#id-62a)","xlink:href":"#id-63b"}}),_c('path',{attrs:{"fill":"#FFF","stroke":"#000","stroke-opacity":".04","d":"M27 21.5h-5.5V27c0 .414-.168.79-.44 1.06a1.495 1.495 0 01-2.121 0A1.495 1.495 0 0118.5 27v-5.5H13c-.414 0-.79-.168-1.06-.44A1.495 1.495 0 0111.5 20c0-.414.168-.79.44-1.06.27-.272.646-.44 1.06-.44h5.5V13c0-.414.168-.79.44-1.06a1.495 1.495 0 012.121 0c.271.27.439.646.439 1.06v5.5H27c.414 0 .79.168 1.06.44a1.495 1.495 0 010 2.121c-.27.271-.646.439-1.06.439z"}})])])
          )
        }
      }
    